import CheckboxItem from '@src/Components/Atoms/CheckboxItem/CheckboxItem';
import React, { useState } from 'react';
import styles from './CheckboxEcosystem.module.scss';
import { CheckboxEcosystemProps } from './CheckboxEcosystem.type';
const list = [
  {
    value: 'mythic-event',
    label: 'Mythic Event'
  },
  {
    value: 'riftstorm',
    label: 'Riftstorm'
  },
  {
    value: 'repository',
    label: 'Repository'
  },
  {
    value: 'event',
    label: 'Event (Mythic report)'
  }
];
const CheckboxEcosystem: React.FC<CheckboxEcosystemProps> = ({
  defaultValue = [],
  onChange
}) => {
  const [checkedValue, setCheckedValue] = useState<number[]>(defaultValue);
  return (
    <div className={styles['Container']} data-testid="checkbox-ecosystem">
      <label>Ecosystem</label>
      <div className={styles['CheckboxContainer']}>
        {list.map((v, i) => (
          <CheckboxItem
            key={v.value}
            defaultState={defaultValue[i] > -1}
            title={v.label}
            onClick={(state: boolean) => {
              setCheckedValue((s) => {
                const t = s;
                t[i] = state ? i : -1;
                return t;
              });
              if (onChange) onChange(checkedValue);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default CheckboxEcosystem;
